import { getConfig, baseUrl } from "./configHelper";
import { saveAs } from 'file-saver';

export function menuSingleItemSelected(items: IMopModifierGroup, isBasket: boolean) {
    console.log(items);
    var out = '';
    items.modifierGroupItems.map((item: any) => {
        if(isBasket){
            if (item.quantitySelected === 1){
                out = item.menuItemName;
            }
        } 
        else{
            if (item.defaultQuantitySelected === 1) {
                out = item.menuItemName;
            }
        }       
    })
    if(!getConfig().isMarket && out == '' && items.minDifferentItems == 1){
        out = items.modifierGroupItems[0].menuItemName;
    }
    return out;
}

export function calculateMenuItemTotalPrice(item?: IMopMenuItemDetail, calcQuantity: boolean = false, isColleague: boolean = false) {
    if (!item) {
        return 0;
    }

    let _basePrice = item.menuItemBasePrice;
    let _price = _basePrice ?? 0;

    const selectedSkus = getSelectedSkus(item.modifierGroups);

    _price = item.modifierGroups.reduce((acc: number, group: IMopModifierGroup) => {
        if (!shouldShowModifierGroup(group, selectedSkus, item.sku)) {
            return acc;
        }

        if (!group.itemsAreChargeable) {
            return acc;
        }

        return group.modifierGroupItems.reduce((acc: number, item: IMopModifierGroupItem) => {
            if (!item.price) {
                return acc;
            }

            return acc + (item.quantitySelected * item.price);
        }, acc);
    }, _price)

    _price = calcQuantity ? _price * item.quantity : _price;

    return _price;
}

export function inlineBrandImage(menuItemName: string, hasBrandImage: boolean, limitSize: boolean = true) {
    if (hasBrandImage) {
        return menuItemName.replace(/\[\[(.+?)\]\]/g, `<img class='${limitSize ? 'inline-image' : ''}' src='${baseUrl()}/images/assets/$1'></img>`);
    }

    return `<span>${menuItemName}</span>`
}

export function showDealHeader(menuItem: IMopMenuItemDetail, isColleague?: boolean): boolean {
    if (isColleague) {
        return false
    }

    if (menuItem.isDealItem) {
        return true;
    }

    return false;
}

export function showModifierGroupsOnPages(menuItem?: IMopMenuItemDetail): boolean {
    if (!menuItem) {
        return false;
    }

    if (menuItem.isDealItem) {
        return true;
    }

    const modifierGroup = menuItem.modifierGroups.find((group: IMopModifierGroup) => {
        if (group.isMandatory && group.canSelectMultiple && group.maxDifferentItems && group.maxDifferentItems > 1) {
            return group;
        }

        return null;
    })

    if (modifierGroup !== undefined) {
        return true;
    }

    return false;
}

function isSafari(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') !== -1 && ua.indexOf('chrome') === -1;
};

export function downloadAllergenFile() {
    const url = `${baseUrl()}/menudata/allergen`;

    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

    var isChrome =
        navigator.userAgent.toLowerCase().indexOf("CriOS") > -1 ||
        navigator.vendor.toLowerCase().indexOf("google") > -1;

    var iOSVersion: number[] = [];
    if (iOS) {
        const version = navigator.userAgent
            .match(/OS [\d_]+/i)

        if (version) {
            iOSVersion = version[0].substr(3).split("_").map((n) => parseInt(n));
        }
    }

    fetch(url)
        .then(response => response.arrayBuffer())
        .then(buffer => {
            let contentType = 'application/pdf';

            if (iOS && !isChrome) {
                contentType = 'application/octet-stream';
            }

            const blob = new Blob([buffer], { type: contentType });
            const blobUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.target = '_blank';

            if ((iOS && (iOSVersion[0] > 12 || isChrome)) || !iOS) {
                link.download = 'Morrisons_cafe_allergens.pdf';
            }

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(blobUrl);
        })
        .catch(console.error)
}

export function getSelectedSkus(modifierGroups: IMopModifierGroup[]): SkuSelection[] {
    let selectedSkus: SkuSelection[] = [];

    modifierGroups.forEach((group: IMopModifierGroup) => {
        let all = group.modifierGroupItems.map((v) => v.sku);
        let selected = group.modifierGroupItems
            .filter((v) => v.quantitySelected > 0)
            .map((v) => v.sku);

        if (!selectedSkus[group.showOnPage]) {
            selectedSkus[group.showOnPage] = { all: all, selected: selected };
        } else {
            selectedSkus[group.showOnPage].all.push(...all);
            selectedSkus[group.showOnPage].selected.push(...selected);
        }
    })

    return selectedSkus;
}

function returnSKUsFromDataTag(dataTag: string) {
    if (!/\[.*\]/.test(dataTag)) {
        dataTag = `[${dataTag}]`
    }
    const regex = /\d+/g;
    const SKUs = dataTag?.match(regex);
    return SKUs
}

function checkSIFIncludes(lhs: string[], rhs: string[]) {
    for (let i = 0; i < lhs.length; i++) {
        if (rhs.includes(lhs[i])) {
            return true;
        }
    }
    return false;
}

export function shouldShowModifierGroup(modifierGroup: IMopModifierGroup, skus: SkuSelection[], mainItemSku?: string): boolean {
    if (!modifierGroup.dataTag) {
        return true;
    }

    let sifs = returnSKUsFromDataTag(modifierGroup.dataTag)

    if (!sifs || sifs.length === 0) {
        return true;
    }

    if (mainItemSku) {
        if (checkSIFIncludes(sifs, [mainItemSku])) {
            return true;
        }
    }

    for (let index = skus.length - 1; index >= 0; index--) {
        // Skip pages later than the current one.
        if (index >= modifierGroup.showOnPage) {
            continue;
        }

        if (!skus[index]) {
            continue;
        }

        // If SIF contains any of the selected ones, show.
        if (checkSIFIncludes(sifs, skus[index].selected)) {
            return true;
        }

        // If all contains any of the SIF, stop here.
        if (checkSIFIncludes(skus[index].all, sifs)) {
            return false;
        }
    }

    return false;
}
